export const tr = {

    upload_max_file : 'En fazla 3 dosya yukleye bilirsiniz.',
    upload_message : 'Dosyayı buraya sürükleyin veya <em>yüklemek için tıklayın.</em>',
    upload_tip_1 : 'Sadece doc, docx ve pdf formatindaki dosyalari yukleye bilirsiniz.',


    notification_warning_title: 'Dikkat!',
    notification_destroy: 'Seçmiş olduğunuz veri kalıcı olarak silinecek. Onaylıyor musunuz?',
    notification_destroy_cancel: 'Silme işlemi iptal edildi.',
    notification_sending_cancel: 'Gönderim işlemi iptal edildi.',
    notification_reCaptchaTitle: 'Robot Değilim',

    dialog_file_upload_title: 'Dosya Yükle',
    dialog_file_upload_description: 'Sorunsuz Baskı ve Yüksek İşçilik Kalitesi',
    dialog_offer_title: 'Teklif İste',
    dialog_offer_description: 'Sorunsuz Baskı ve Yüksek İşçilik Kalitesi',

    misc_or: 'Veya',
    misc_yes: 'Evet',
    misc_no: 'Hayır',
    misc_search_not_found: 'Üzgünüm aramanıza uygun sonuç bulunamadı.',

    inputs_choice: 'Seçiminiz',
    inputs_your_message: 'Mesajınız...',
    inputs_your_email: 'E-posta Adresiniz',
    inputs_email: 'E-posta',
    inputs_first_name: 'Ad',
    inputs_last_name: 'Soyad',
    inputs_your_phone: 'Telefon Numaranız',
    inputs_phone: 'Telefon',
    inputs_country: 'Ülke',
    inputs_city: 'Şehir',
    inputs_town: 'İlçe',
    inputs_subject: 'Konu',
    inputs_message: 'Mesaj',
    inputs_your_full_name: 'Adınız Soyadınız',
    inputs_full_name: 'Ad Soyad',
    inputs_has_access_web_site: 'Web sitesinde yayınlanmasına izin veriyorum.',

    button_send: 'Gönder',
    button_save: 'Kaydet',
}
